import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
    .rfpSubmit,
    .rfpClear {
        border-radius: 0;
        min-width: ${toRem(170)};
        @media ${theme.mediaQuery.mobileOnly} {
          min-width: 132px;
        }
    }
    .rfpClear {
      margin-left: ${toRem(8)};
      @media ${theme.mediaQuery.tablet} {
        margin-left: ${toRem(48)};
      }

      [dir="rtl"] & {
        margin-left: unset;
        margin-right: ${toRem(8)};
        @media ${theme.mediaQuery.tablet} {
          margin-left: unset;
          margin-right: ${toRem(48)};
        }
      }
    }
    body & {
      .m-input-field {
        input {
          border-radius: 0;
          border-color: #646464;
        }
        label {
          padding: 0 4px;
          left: ${toRem(17)};

          [dir="rtl"]  & {
            left: unset;
            right: ${toRem(17)};
          }
        }
      }
      .DayPicker-Day {
        border-radius: 0;
      }
    }
    .error-text {
      color: var(--t-form-error-color);
    }
    .dropdown-panel {
      width: 96.7% !important;
    }
    .rfp-modal-content {
      margin: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      min-height: ${toRem(507)};
      width: 90%;
      @media ${theme.mediaQuery.tablet} {
        width: ${toRem(596)};
      }
      @media ${theme.mediaQuery.minDesktop} {
        min-height: ${toRem(440)};
        width: ${toRem(1000)};
      }
      &__title {
        max-width: ${toRem(287)};
        @media ${theme.mediaQuery.minDesktop} {
          max-width: ${toRem(620)};
        }
      }
      &--close {
        position: absolute;
        top: ${toRem(30)};
        right: ${toRem(30)};

        [dir="rtl"] & {
          right: unset;
          left: ${toRem(30)};
        }

        cursor: pointer;
        background: transparent;
        @media ${theme.mediaQuery.tablet} {
          top: ${toRem(48)};
          right: ${toRem(40)};

          [dir="rtl"] & {
            right: unset;
            left: ${toRem(40)};
          }
        }
        .icon-clear {
          font-size: ${toRem(32)};
        }
      }
    }

  .m-input-field {
    caret-color: inherit;
    &.is-error {
      label,
      span:first-of-type {
        color: unset;
      }
      .error-text {
        color: var(--t-form-error-color) !important;
      }
    }

    .icon-arrow {
      [dir="rtl"] & {
        top: ${toRem(15)} !important;
      }
    }
  }
  .error {
    label:before {
    border: 1px solid var(--t-form-error-color) !important;
    }
  }
  .col-xl-6 {
    width: 100%;
  }
`}
`;
